<span id="legislacao"></span>

<div class="content">
  <div>
    <h2>Legislação</h2>

    <ul class="leg-grid">
      <ng-container *ngFor="let col of columns">
        <li
          class="leg-item"
          *ngFor="let it of col"
          [attr.title]="it.title"
          (click)="downloadByItem(it)"
          (keydown)="onItemKeydown($event, it)"
          tabindex="0"
          role="button"
        >
          <span class="leg-title">{{ it.title }}</span>
          <span class="leg-btn" aria-hidden="true"></span>
        </li>
      </ng-container>
    </ul>
  </div>

  <img src="/assets/images/images/puzzle.svg" alt="legislacao" />
</div>

<div class="button-div">
  <button class="button-view" [routerLink]="['/listagem-legislacao']">Veja mais</button>
</div>
